document.addEventListener('invalid', (event) => {
  const field = event.target;
  if (!field.closest?.('[data-tet-form-state]')) return;
  field.setAttribute('aria-invalid', 'true');
}, true);

document.addEventListener('input', (event) => {
  const field = event.target;
  if (!field.closest?.('[data-tet-form-state]') || typeof field.checkValidity !== 'function') return;
  if (field.checkValidity()) field.removeAttribute('aria-invalid');
}, true);

document.addEventListener('submit', (event) => {
  const form = event.target;
  const stateRoot = form.closest?.('[data-tet-form-state]');
  if (!stateRoot || typeof form.checkValidity !== 'function' || !form.checkValidity()) return;

  const submitButton = form.querySelector('[type="submit"][data-submitting-label]');
  if (!submitButton) return;
  submitButton.disabled = true;
  submitButton.setAttribute('aria-disabled', 'true');
  submitButton.textContent = submitButton.dataset.submittingLabel;
}, true);
